// en.js
export const locale = {
    GENERAL: {
        NAV_OPTIONS: ['Home', 'About', 'Contact'],
        WELCOME_WORD: 'Welcome to your Vue.js application',
        OK: 'ok',
        CONTINUE: 'continue',
        CANCEL: 'cancel',
        GUEST: 'guest',
    },
    language: {
      select: "LANGUAGE",
      tw: "Chinese",
      en: "English"
    },
    NAV_MENU:{
        NEWS: 'NEWS',
        SOLUTION: 'SOLUTION',
        ACTIVITY: 'ACTIVITY',
        ABOUT_SMC: 'ABOUT SMC',
        SAMPLE_CASE: 'SAMPLE CASE',
        CONTACT: 'CONTACT',
    },
    NAV_SUB_MENU:{
        History: 'History',
        Members: 'Members',
        Achievements: 'Achievements',
        _1F: 'Space tour 1F',
        _2F: 'Space tour 2F',
        Case_BDI: 'BDI Group',
        _Contact: 'Contact us',
        Location: 'Location',
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/config/i18n/en.js
// module id = null
// module chunks = 